// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"473a160f","623":"5a3bf801","787":"1622b7c0"}[chunkId] + ".chunk.js";
};